import React, { type FC } from 'react';

import { gettext } from '@eventbrite/i18n';

import { FollowButtonContext } from './context';

import { Button } from '@eventbrite/eds-button';

import './FollowButton.scss';

type TFollowButtonProps = {
    pageArea: string;
    shouldPreventPropogation?: boolean;
};

const FOLLOW_TEXT = gettext('Follow');
const FOLLOWING_TEXT = gettext('Following');

export const useFollowButton = () => {
    const followButtonProps = React.useContext(FollowButtonContext);
    return {
        isFollowing: followButtonProps?.isFollowing || false,
        onFollowClick: followButtonProps?.onFollowClick,
    };
};

export const useFollowCount = () => {
    const followButtonProps = React.useContext(FollowButtonContext);
    return followButtonProps?.followersCount;
};

export const FollowButton: FC<TFollowButtonProps> = ({
    pageArea,
    shouldPreventPropogation,
}) => {
    const { isFollowing, onFollowClick } = useFollowButton();
    return (
        <Button
            style={'follow'}
            onClick={(e: MouseEvent) => {
                onFollowClick?.(pageArea);
                if (shouldPreventPropogation) {
                    e.stopPropagation();
                }
            }}
            isFollowing={isFollowing}
            __containerClassName="follow-button-listing-page"
        >
            {isFollowing ? FOLLOWING_TEXT : FOLLOW_TEXT}
        </Button>
    );
};
